import React from 'react';
import {
    styled,
    SxProps,
    Theme,
    Typography,
    TypographyProps,
} from '@mui/material';

const Base = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: theme.spacing(0.5),
    marginTop: '-2px',
}));

const Separator = styled(Typography)({
    userSelect: 'none',
});

interface MetadataDisplayProps {
    parts: string[];
    variant?: TypographyProps['variant'];
    color?: string;
    separator?: string;
    weight?: number;
    noWrap?: boolean;
    sx?: SxProps<Theme>;
}

export const MetadataDisplay = ({
    parts,
    variant = 'caption',
    color = 'textSecondary',
    separator = '•',
    weight = 400,
    noWrap = false,
    sx,
}: MetadataDisplayProps) => {
    const validParts = parts.filter(
        part => Boolean(part) && part.trim() !== ''
    );

    if (noWrap) {
        return validParts.length > 0 ? (
            <Typography
                variant={variant}
                color={color}
                fontWeight={weight}
                noWrap
                sx={sx}>
                {validParts.join(` ${separator} `)}
            </Typography>
        ) : null;
    }

    return (
        <Base sx={sx}>
            {validParts.map((part, index) => (
                <React.Fragment key={index}>
                    {index > 0 && (
                        <Separator
                            variant={variant}
                            color={color}
                            fontWeight={weight}>
                            {separator}
                        </Separator>
                    )}
                    <Typography
                        variant={variant}
                        color={color}
                        whiteSpace='nowrap'
                        fontWeight={weight}>
                        {part}
                    </Typography>
                </React.Fragment>
            ))}
        </Base>
    );
};
